import { useEffect, useState } from "react";
import { Singleton } from "../../../../core/services/Singleton";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _ExportProdcutionOrderIn, _ExportProductionOrders, _liquidateProduction, _MaterialAdjustment, _OrderCatalogForExternal, _OrderCatalogInProgress, _ProductionOrderStandardImp, _ProductionOrderTicket, _RawMaterialClose, _TimeEventStandard, _UpdateProdcutionOrderIn } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { _DocumentFactory, _ProductionOrder, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { DropDown } from "../../../theme/Component/DropDown";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectProductEditor } from "../../ManufacturingStandars/Components/SelectProductEditor";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { SelectManufacturingStandars } from "../../ManufacturingStandars/SelectManufacturingStandars";
import { SelectAttentionOffice } from "../Components/SelectAttentionOffice";
import { StateConstantsForWIP } from "../../ScheduleProductionOrder/StateConstantsForWIP/StateConstantsForWIP";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { Modal } from "../../../theme/Component/Modal";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { RawMaterialRequestCatalog } from "../RawMaterialRequestCatalog/RawMaterialRequestCatalog";
import { MaterialAvailableProductionOrder } from "../../../RemoteAbstractAction/components/com/quickdataerp/actions/MaterialAvailableProductionOrder";
import { CostProductionOrderCatalog } from "../getCostProductionOrderCatalog/CostProductionOrderCatalog";
import { ProductionOrderRemission } from "../ProductionOrderRemission";
import { TraslateProdcutProccesFinished } from "../RawMaterialRequestCatalog/TraslateProdcutProccesFinished/TraslateProdcutProccesFinished";
import { OrderToWIP } from "../OrderToWIP/OrderToWIP";
import { ProductionOrderDocuments } from "../ProductionOrderDocuments/ProductionOrderDocuments";
import { TimeMovements } from "../Components/TimeMovements/TimeMovements";
import AutoChart from "../../../../core/graph/AutoChart";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectStoreEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { SelectProductionOrderRequestConstants } from "../Components/SelectProductionOrderRequestConstants";
import { SelectProductVariant } from "../../../Inventories-Warehouses/Product/ProductVariant/SelectProductVariant";
import { ManufacturingStandarsEditor } from "../../ManufacturingStandars/ManufacturingStandarsEditor";
import { SelectProductionRoute } from "../../ProductionRoute/SelectProductionRoute";
import { SelectBusinessCore } from "../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { ExternalFactoryEditor } from "../ExternalFactory/ExternalFactoryEditor";




export const OrderCatalogForExternal = () => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_OrderCatalogForExternal);
    const single = Singleton.getInstance();
    const exportproduction = useDataBean(_ExportProductionOrders);
    const paginador = usePaginator();
    const generateticket = useDataBean(_ProductionOrderTicket);
    const UpdateOrder = useDataBean(_UpdateProdcutionOrderIn);
    const ExportOrder = useDataBean(_ExportProdcutionOrderIn);
    const standardproduction = useDataBean(_ProductionOrderStandardImp);
    const Ajustar = useDataBean(_MaterialAdjustment);
    const Devolucion = useDataBean(_RawMaterialClose);
    const liquidar = useDataBean(_liquidateProduction);
    const order = useDataBean(_ProductionOrder);
    const _documentos = useDataBean(_DocumentFactory);
    const [exportxsl, setexportxsl] = useState<number>(null)
    const [registers, setRegisters] = useState<number>(15)
    const [formato, setFormato] = useState<any>([]);
    const [formatodos, setFormatodos] = useState<any>([]);
    const [formatotres, setFormatotres] = useState<any>([]);
    const [formatocuatro, setFormatocuatro] = useState<any>([]);
    const [obs, setObs] = useState<string>("")
    const TimeEventStandard = useDataBean(_TimeEventStandard);
    const [docs, setDocs] = useState<any>([]);
    const [docsvdos, setDocsvdos] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);
    const [docsvtres, setDocsvtres] = useState<any>([]);
    const [docsliquidation, setDocsliquidation] = useState<any>([]);
    const [docsvcuatro, setDocsvcuatro] = useState<any>([]);
    const modalGraph = useModal("Grafica", MODAL_XL);
    const [docsvcinco, setDocsvcinco] = useState<any>([]);
    const [formatoticket, setFormatoticket] = useState<any>([]);
    const [standardsdocs, setStandardsdocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [costeoestandard, setCosteoestandard] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalticket, setModalticket] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalDocliquidar, setModalDocliquidar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaltime, setModaltime] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [exportdocs, setModalexportdocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdocs, setModalverdocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [actualizar, setActualizar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldescargar, setModaldescargar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalregister, setModalregister] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [ajustardocs, setajustardocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [devoluciondocs, setdevoluciondocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [liquidardocs, setliquidardocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalajustar, setModalajustar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldevolucion, setModaldevolucion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalliquidar, setModalliquidar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaltrasladoprocces, setModaltrasladoprocces] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcost, setModalcost] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [inventory, setInventory] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [consultar, setConsultar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [exportproductionordenbyaccion, setexportproductionordenbyaccion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-md' });
    const [exportexel, setexportexel] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [reporte, setDescargarreporte] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [finalizarorden, setFinalizarorden] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [detenerorden, setDetenerorden] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [ejecutarorden, setEjecutarorden] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [traslados, setTraslados] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [form, setForm] = useState<any>({
        IDAccount: NaN,
        Year: _single.getCurrenYear(),
        MonthVigency: NaN,
        FromDate: null,
        UptoDate: null,
        IDExternalFactory: null,
        NameExternal: null,
        IDProduct: null,
        IDProject: NaN,
        IDManufacturingStandart: NaN,
        IDAttentionOffice: NaN,
        IDStore: NaN,
        State: NaN,
    })
    const [formtwo, setFormtwo] = useState<any>({

        year: _single.getCurrenYear(),
        month: NaN,

    })
    useEffect(() => {
        if (modalDocliquidar.view) {
            verDocumentosliquidacion();
        }
    }, [modalDocliquidar.view]);
    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getLista = () => {

        instance.getProductionOrderCatalogForExternalFactory(form.IDExternalFactory, form.IDAccount, form.IDProduct, form.Code, form.Year, form.MonthVigency, form.IDManufacturingStandart, form.IDAttentionOffice, null, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    const x = resp.List.map(element => {
                        element.DataBeanProperties.Measurement = element.DataBeanProperties.MeasurementUnitCode ? `${element.DataBeanProperties.MeasurementUnitCode} - ${element.DataBeanProperties.MeasurementUnitName}` : "N/A"
                        element.DataBeanProperties.DocLiquidation = element.DataBeanProperties.Mnemonic ? `${element.DataBeanProperties.Consecutive} - ${element.DataBeanProperties.DocumentDate}` : "Sin Documento"
                        return element;
                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        setBean({

        });
        setModal({ ...modal, "view": true });
    }

    const exportProductionOrdersbyaccion = () => {
        exportproduction.instance.exportProductionOrders(bean.IDProductionOrder, bean.ProductionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    setFormatotres(resp[0]);
                    setexportproductionordenbyaccion({ ...exportproductionordenbyaccion, "view": true, "name": "Generar Reporte de Orden de Producción" })
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const verDocumentosliquidacion = () => {

        if (bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(bean.IDDocument, null, bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocsliquidation(resp.DocumentURL);

                }
            )
        } else {
            toast.warning("No hay documento asociado de liquidación");
        }

    }
    const ejecutarlaordendeproduccion = () => {
        order.instance.postProductionOrderToProductionProcess(
            bean.IDProductionOrder,
            bean.ProductionOrderDate,
            _single.getAccountID(),
            bean.Observations
        ).then((resp: any) => {
            if (resp) {
                console.log(resp);
                setMsgList(resp.MsgList);

                // ✅ Mostrar cada mensaje del backend en un toast
                resp.MsgList?.forEach((msg: string) => {
                    toast.info(msg);
                });

                setEjecutarorden({ ...ejecutarorden, name: "Ejecutar", view: false });
            }
        }).catch(err => {
            toast.error(err);
        });
    };
    const detenerordendeproduccion = () => {
        order.instance.rejectProductionOrderToProductionProcess(bean.IDProductionOrder, bean.ProductionOrderDate, _single.getAccountID(), obs).then(
            (resp: any) => {
                if (resp) {
                    setDetenerorden({ ...detenerorden, "name": `Detener`, "view": false });
                    setObs("");
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )

    }

    useEffect(() => {
        if (reporte && bean?.IDProductionOrder) {
            descargarreporteproduccion();
        }
    }, [reporte]);
    const descargarreporteproduccion = () => {

        order.instance.getProductionOrderReport(bean.IDProductionOrder, bean.ProductionOrderDate).then(
            (resp: any) => {
                if (resp && resp.length > 0) {
                    setFormato(resp[0]);
                    console.log(resp[0]);
                    setMsgList(resp.MsgList);

                    // ✅ Mostrar cada mensaje del backend en un toast
                    resp.MsgList?.forEach((msg: string) => {
                        toast.info(msg);
                    });
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )

    }
    const updateProductionOrderInProgressData = () => {
        UpdateOrder.instance.updateProductionOrderInProgressData(formtwo.year).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Actualizado')
                    setActualizar({ ...actualizar, "name": `Finalizar`, "view": false })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const editaItem = () => {
        order.instance.updateProductionOrder(bean).then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }
    const exportWIPProductionOrders = () => {
        ExportOrder.instance.exportWIPProductionOrders(formtwo.year, formtwo.month).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Exportado')
                    // setDocsvcuatro(resp.DocumentURL)
                    setFormatocuatro(resp[0]);
                    setModaldescargar({ ...modaldescargar, "view": false })
                    setModalexportdocs({ ...exportdocs, "view": true })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const finalizarordendeproduccion = () => {
        order.instance.postProductionOrderAsFinished(bean.IDProductionOrder, bean.ProductionOrderDate, _single.getAccountID(), obs).then(
            (resp: any) => {
                if (resp) {
                    setObs("");
                    setFinalizarorden({ ...finalizarorden, "name": `Finalizar`, "view": false })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const createRawMaterialAdjustmentForProductionOrder = () => {
        Ajustar.instance.createRawMaterialAdjustmentForProductionOrder(Ajustar.bean.IDStoreDestinity, bean.IDProductionOrder, bean.ProductionOrderDate, Ajustar.bean.AccountantDate, Ajustar.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Ajustado')
                    setDocs(resp.DocumentURL);
                    setModalajustar({ ...modalajustar, "view": false })
                    setajustardocs({ ...ajustardocs, "view": true })

                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const createRawMaterialCloseForProductionOrder = () => {
        Devolucion.instance.createRawMaterialCloseForProductionOrder(bean.IDProductionOrder, bean.ProductionOrderDate, Devolucion.bean.IDStoreDestinity, Devolucion.bean.AccountantDate, Devolucion.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Devolucion Realizada')
                    setDocsvdos(resp.DocumentURL);
                    setModaldevolucion({ ...modaldevolucion, "view": false })
                    setdevoluciondocs({ ...devoluciondocs, "view": true })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const updateProductionOrderStandardImp = () => {
        standardproduction.instance.updateProductionOrderStandardImp(bean.IDProductionOrder, bean.ProductionOrderDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Estandard Actualizado');
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const getProductionOrderTicket = () => {
        generateticket.instance.getProductionOrderTicket(bean.IDProductionOrder, bean.ProductionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Tickect Generado')
                    setFormatoticket(resp[0]);
                    setModalticket({ ...modalticket, "view": true })
                    console.log(resp)
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const liquidateProductionOrder = () => {
        liquidar.instance.liquidateProductionOrder(bean.IDProductionOrder, bean.ProductionOrderDate, liquidar.bean.IDStoreDestinity, liquidar.bean.AccountantDate, liquidar.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Orden Liquidada')
                    setDocsvtres(resp.DocumentURL);
                    setModalliquidar({ ...modalliquidar, "view": false })
                    setliquidardocs({ ...liquidardocs, "view": true })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const head = [
        { title: 'ID', property: 'IDProductionOrder', visible: true },
        { title: 'Fecha de la Orden de Producción', property: 'ProductionOrderDate', visible: true },
        { title: 'Fecha Inicio Plan', property: 'InitDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Fin Plan', property: 'UptoDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Real Inicio', property: 'RealInitDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Real Finalización', property: 'RealUptoDate', visible: true, mask: MASK_DATE },
        { title: 'Producto a Producir', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'Measurement', visible: true },
        { title: 'Usar Maquila Externa', property: "UseExternalFactory", visible: true },
        { title: 'Maquila/CentroExterno', property: "ExternalFactoryName", visible: true },
        { title: 'Plan de Producción', property: "ProductionPlanName", visible: true },
        { title: 'Cantidad a Producir', property: 'Quantity', visible: true },
        { title: 'Cantidad Producto Terminado', property: 'FinishedProductQuantity', visible: true },
        { title: 'Cantidad Pendiente a Producir', property: 'PendingQuantity', visible: true },
        { title: 'Valor Inventario que Ingresa a OP', property: 'RawMaterialCostInput', visible: true, mask: MASK_MONEY },
        { title: 'Valor Inventario Línea Producción', property: 'RawMaterialCostOutput', visible: true, mask: MASK_MONEY },
        { title: 'Valor Inventario Disponible OP', property: 'LeftRawMaterial', visible: true, mask: MASK_MONEY },
        { title: 'Valor Costos Ingresados OP', property: 'CostInputValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor Costos Transformados/Descargados', property: 'CostOutputValue', visible: true, mask: MASK_MONEY },
        { title: 'Costos Pendientes por Transformar', property: 'LeftCosts', visible: true },
        { title: 'Valor WIP Ingresa', property: 'WIPInputValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor Producto Terminado', property: 'FinishedProductCost', visible: true, mask: MASK_MONEY },
        { title: 'Saldo WIP', property: 'WIPLeft', visible: true },
        { title: 'Cantidad Remisionada', property: 'RemissionQuantity', visible: true },
        { title: 'Valor Producto Remisionado', property: 'RemissionValue', visible: true, mask: MASK_MONEY },
        { title: 'Centro de Fabricación', property: 'AttentionOfficeName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Estado de la Operación', property: 'OrderStateName', visible: true },
        { title: 'Document de Liquidación/Cierre', property: 'DocLiquidation', visible: true },
    ]
    const resetObservations = () => {
        setBean(prev => ({ ...prev, Observations: '' }));
    };
    const verbyactualizar = () => {
        setActualizar({ ...actualizar, "view": true })
    };
    const verbydescargar = () => {
        setModaldescargar({ ...modaldescargar, "view": true })
    };
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ajustar Costos de Material', icono: 'ri-swap-box-fill', visible: true, evento: () => { setModalajustar({ ...modalajustar, "view": true }) } },
            // { titulo: 'Actualizar Estandard de Fabricación', icono: 'bx bx-food-menu', visible: true, evento: () => { updateProductionOrderStandardImp() } },
            { titulo: 'Consultar Solicitudes de Materia Prima', icono: 'ri-file-search-line', visible: true, evento: () => { setConsultar({ ...consultar, "view": true, "name": "Consultar Solicitudes de Materia Prima" }) } },
            { titulo: 'Costos de Orden de Producción', icono: 'ri-refund-2-line', visible: true, evento: () => { setModalcost({ ...modalcost, "view": true }) } },
            {
                titulo: 'Detener Ejecución de Orden de Producción',
                icono: 'ri-file-forbid-line',
                visible: _single.canEdit(),
                evento: () => {
                    resetObservations();
                    setDetenerorden({ ...detenerorden, view: true, name: 'Detener Orden de Producción' });
                }
            },
            // { titulo: 'Exportar a Excel Orden de Producción', icono: 'ri-edit-2-line', visible: true, evento: () => { setFormato({}); setexportproductionordenbyaccion({ ...exportproductionordenbyaccion, "view": true, "name": "Generar Reporte de Orden de Producción" }) } },
            { titulo: 'Exportar a Excel Orden de Producción', icono: 'ri-file-chart-fill', visible: true, evento: () => { exportProductionOrdersbyaccion() } },
            {
                titulo: 'Ejecutar Orden de Producción',
                icono: 'ri-send-plane-fill',
                visible: _single.canEdit(),
                evento: () => {
                    resetObservations();
                    setEjecutarorden({ ...ejecutarorden, view: true, name: 'Ejecutar Orden de Producción' });
                }
            },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Orden de Producción" }) } },
            { titulo: 'Eliminar', icono: 'ri-file-excel-fill', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Orden de Producción` }) } },
            {
                titulo: 'Finalizar Orden de Producción',
                icono: 'ri-file-transfer-line',
                visible: _single.canEdit(),
                evento: () => {
                    resetObservations();
                    setFinalizarorden({ ...finalizarorden, view: true, name: 'Finalizar Orden de Producción' });
                }
            },
            { titulo: 'Generar Reporte de Orden de Producción', icono: ' ri-file-download-line', visible: true, evento: () => { setFormato({}); setDescargarreporte({ ...reporte, "view": true, "name": "Generar Reporte de Orden de Producción" }) } },
            { titulo: 'Generar Ticket de Producción', icono: 'bx bx-bookmark-alt-minus', visible: true, evento: () => { getProductionOrderTicket() } },
            { titulo: 'Generar Contabilización de Costeo Estandard', icono: ' ri-file-download-line', visible: true, evento: () => { setCosteoestandard({ ...costeoestandard, "view": true, "name": "Generar Contabilización de Costeo Estandard" }) } },
            { titulo: 'Inventario Disponible en Orden de Producción', icono: 'ri-file-unknow-fill', visible: true, evento: () => { setInventory({ ...inventory, "view": true }) } },
            // { titulo: 'Lotes de Producción', icono: 'bx bx-box', visible: true, evento: () => { setModallotes({ ...modallotes, "view": true }) } },
            { titulo: 'Liquidar Orden de Producción', icono: 'ri-file-damage-line', visible: true, evento: () => { setModalliquidar({ ...modalliquidar, "view": true }) } },
            { titulo: 'Registros de Producto en Proceso', icono: 'ri-list-unordered', visible: true, evento: () => { setModalregister({ ...modalregister, "view": true }) } },
            { titulo: 'Realizar Devolución de Materia Prima a Almacén', icono: 'ri-swap-fill', visible: true, evento: () => { setModaldevolucion({ ...modaldevolucion, "view": true }) } },
            { titulo: 'Tiempos y Movimientos', icono: 'bx bx-sort', visible: true, evento: () => { setModaltime({ ...modaltime, "view": true }) } },
            { titulo: 'Traslados de Producto en Proceso a Producto Terminado', icono: 'ri-line-height', visible: true, evento: () => { setModaltrasladoprocces({ ...modaltrasladoprocces, "view": true }) } },
            { titulo: 'Ver Traslados de Producto Terminado a Remisión/Almacén', icono: 'ri-phone-find-line', visible: _single.canEdit(), evento: () => { setTraslados({ ...traslados, "view": true, "name": "Ver Traslados de Producto Terminado a Almacén" }) } },
            { titulo: 'Ver Documentos de la Orden de Producción', icono: 'ri-swap-box-fill', visible: true, evento: () => { setModalverdocs({ ...modalverdocs, "view": true }) } },
            { titulo: 'Ver Documento de Liquidación', icono: 'bx bxs-file-doc', visible: true, evento: () => { setModalDocliquidar({ ...modalDocliquidar, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const actionsDropDown = [
        { id: 1, name: 'Reporte Grafico', permiso: null, activo: true },


    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {

                            modalGraph.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }
    const createTimeEventStandardForProductionOrder = () => {
        TimeEventStandard.instance.createTimeEventStandardForProductionOrder(bean.IDProductionOrder, bean.ProductionOrderDate, TimeEventStandard.bean.AccountantDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Contabilización de Costeo Estandard Exitoso')
                    setDocsvcinco(resp.DocumentURL);
                    setCosteoestandard({ ...costeoestandard, "view": false })
                    setStandardsdocs({ ...standardsdocs, "view": true })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    return (
        <BasicPage titulo="Ordenes de Producción en Maquila/Producción Externa">
            <div className="row">
                <div className="col-md-4">
                    <label>Centro de Producción Externa/Maquila</label>
                    <ExternalFactoryEditor render={form.NameExternal} idSelector={form.IDExternalFactory} onChange={(e) => { setForm({ ...form, "IDExternalFactory": e.IDExternalFactory, "NameExternal": e.Name }) }} label=" " returnType="Object" />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={null} label="Cliente" onChange={(e) => { setForm({ ...form, "IDAccount": e.IDAccount }) }} />
                </div>
                <div className="col-md-4">
                    <SelectProductEditor label="Producto Final" value={form.IDProduct} onChange={(e) => { setForm({ ...form, "IDProduct": e.IDProduct }) }} />
                </div>
                <div className="col-md-4">
                    <label >Código de Orden</label>
                    <input type="number" className="form-control" value={form.Code} onChange={(e) => { setForm({ ...form, "Code": e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <label >Año/Vigencia</label>
                    <YearSelector tittle=" " onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                </div>
                <div className="col-md-4">
                    <label >Mes</label>
                    <MonthConstantsEditor idSelect={form.MonthVigency} onChange={(e) => { setForm({ ...form, "MonthVigency": e }) }} label=" " name="" />
                </div>
                <div className="col-md-4">
                    <SelectManufacturingStandars idSelector={form.IDManufacturingStandart} onChange={(e) => { setForm({ ...form, "IDManufacturingStandart": e }) }} label="Estandard de Fabricación" />
                </div>
                <div className="col-md-4">
                    <SelectAttentionOffice idSelector={form.IDAttentionOffice} onChange={(e) => { setForm({ ...form, "IDAttentionOffice": e }) }} label="Centro de Fabricación" />
                </div>
                <div className="col-md-4">
                    <StateConstantsForWIP label='Estado de la Orden de Producción' idSelector={form.State} onChange={(e) => { setForm({ ...form, "State": e }) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-bar-chart-grouped-fill" clase="btn btn-outline-primary btn-border" eventClick={verbyactualizar}>
                        Actualizar Datos de Producción
                    </BasicButton>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-file-chart-fill" clase="btn btn-outline-primary btn-border" eventClick={verbydescargar}>
                        Descargar Cronograma de Producción
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={setBean} listButtons={listaBotones()}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={15}></BasicTable>


                </div>
                <div className="col-md-12">
                    <Modal modal={exportproductionordenbyaccion} updateModal={setexportproductionordenbyaccion}>
                        <>
                            <div className="row">
                                {/* <div className="col-md-6">
                                <BasicButton eventClick={exportProductionOrdersbyaccion} icon="ri-inbox-archive-line" children={"Exportar a Excel Ordenes de Producción"} />
                            </div> */}

                                <div className="col-md-12">
                                    {formatotres?.DataBeanProperties?.URLLink && (
                                        // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                        <div className="row">
                                            <div className="col-md-12 mt-3">
                                                <label>Descarga en el Siguiente Link:*</label>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <a href={formatotres.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                    <strong>{formatotres.DataBeanProperties.Filename}</strong>
                                                </a>
                                            </div>
                                        </div>

                                    )}
                                </div>
                            </div>

                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalDocliquidar} updateModal={setModalDocliquidar}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docsliquidation}
                                    IDDocument={bean.IDDocument}
                                    Since={bean.DocumentDate}
                                />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={consultar} updateModal={setConsultar}>
                        <>
                            <RawMaterialRequestCatalog idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                        </>
                    </Modal>
                    <Modal modal={inventory} updateModal={setInventory}>
                        <>
                            <MaterialAvailableProductionOrder idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                        </>
                    </Modal>
                    <Modal modal={modalcost} updateModal={setModalcost}>
                        <>
                            <CostProductionOrderCatalog idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={actualizar} updateModal={setActualizar} eventModal={updateProductionOrderInProgressData}>
                        <div className="row">
                            <div className="col-md-6">
                                <YearSelector value={formtwo.year} tittle="Año" onChange={(e: any) => { setFormtwo({ ...formtwo, "year": e }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modaldescargar} updateModal={setModaldescargar} eventModal={exportWIPProductionOrders}>
                        <div className="row">
                            <div className="col-md-6">
                                <YearSelector value={formtwo.year} tittle="Año" onChange={(e: any) => { setFormtwo({ ...formtwo, "year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthConstantsEditor idSelect={formtwo.month} onChange={(e: any) => { setFormtwo({ ...formtwo, "month": e }) }} label="Mes" name="" />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={traslados} updateModal={setTraslados}>
                        <ProductionOrderRemission idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={modaltrasladoprocces} updateModal={setModaltrasladoprocces}>
                        <>
                            <TraslateProdcutProccesFinished idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                        </>

                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalregister} updateModal={setModalregister}>
                        <>
                            <OrderToWIP idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                        </>

                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalverdocs} updateModal={setModalverdocs}>
                        <>
                            <ProductionOrderDocuments idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                        </>

                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modaltime} updateModal={setModaltime}>
                        <>
                            <TimeMovements idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                        </>

                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista.filter((item) => item.DataBeanProperties.Type != null)} head={head} useIndexAsXLabel={true}
                            xOptions={['ProductName', 'ProductionOrderDate', 'InitDate', 'Measurement', 'OrderStateName']}
                            yOptions={['RawMaterialCostInput', 'RawMaterialCostOutput', 'LeftRawMaterial', 'CostInputValue', 'CostOutputValue', 'LeftCosts', 'WIPInputValue', 'FinishedProductCost', 'WIPLeft', 'Month9Value', 'RemissionQuantity', 'RemissionValue']} />

                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={ejecutarorden} updateModal={setEjecutarorden} eventModal={ejecutarlaordendeproduccion} onSubmitLabel="Ejecutar Orden"  >
                        <div className="row">
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={bean.Observations || ""} onChange={handleChange} />

                            </div>
                            {/* <div className="col-md-6 mt-3">
                                            <BasicButton eventClick={ejecutarlaordendeproduccion} icon="ri-folder-upload-fill" >
                                                Ejecutar Orden
                                            </BasicButton>
                                        </div> */}

                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={costeoestandard} updateModal={setCosteoestandard} eventModal={createTimeEventStandardForProductionOrder} onSubmitLabel="Generar Contabilización de Costeo Estandard">
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate name="AccountantDate" value={TimeEventStandard.bean.AccountantDate} label="Fecha de Contabilización" setDate={(e) => { TimeEventStandard.setBean({ ...TimeEventStandard.bean, "AccountantDate": e }) }} />
                            </div>

                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={detenerorden} updateModal={setDetenerorden} eventModal={detenerordendeproduccion} onSubmitLabel="Detener Orden">
                        <div className="row">
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                            </div>
                        </div>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <Modal modal={finalizarorden} updateModal={setFinalizarorden} eventModal={finalizarordendeproduccion} onSubmitLabel="Finalizar Orden">
                        <div className="row">
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Observations" className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalajustar} updateModal={setModalajustar} eventModal={createRawMaterialAdjustmentForProductionOrder} onSubmitLabel="Ajustar Costos de Material">
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate name="AccountantDate" value={Ajustar.bean.AccountantDate} label="Fecha de Registro Contable" setDate={(e) => { Ajustar.setBean({ ...Ajustar.bean, "AccountantDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectStoreEditor label="Almacén Destino" idSelector={Ajustar.bean.IDStoreDestinity} onChange={(e) => { Ajustar.setBean({ ...Ajustar.bean, "IDStoreDestinity": e.IDStore }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Description" className="form-control" value={Ajustar.bean.Description} onChange={(e) => { Ajustar.setBean({ ...Ajustar.bean, 'Description': e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modaldevolucion} updateModal={setModaldevolucion} eventModal={createRawMaterialCloseForProductionOrder} onSubmitLabel=" Realizar Devolución de Materia Prima a Almacén">
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate name="AccountantDate" value={Devolucion.bean.AccountantDate} label="Fecha de Registro Contable" setDate={(e) => { Devolucion.setBean({ ...Devolucion.bean, "AccountantDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectStoreEditor label="Almacén Destino" idSelector={Devolucion.bean.IDStoreDestinity} onChange={(e) => { Devolucion.setBean({ ...Devolucion.bean, "IDStoreDestinity": e.IDStore }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Description" className="form-control" value={Devolucion.bean.Description} onChange={(e) => { Devolucion.setBean({ ...Devolucion.bean, 'Description': e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalliquidar} updateModal={setModalliquidar} eventModal={liquidateProductionOrder} onSubmitLabel="Liquidar Orden de Producción">
                        <div className="row">
                            <div className="col-md-6">
                                <InputDate name="AccountantDate" value={liquidar.bean.AccountantDate} label="Fecha de Registro Contable" setDate={(e) => { liquidar.setBean({ ...liquidar.bean, "AccountantDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectStoreEditor label="Almacén Destino" idSelector={liquidar.bean.IDStoreDestinity} onChange={(e) => { liquidar.setBean({ ...liquidar.bean, "IDStoreDestinity": e.IDStore }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Description" className="form-control" value={liquidar.bean.Description} onChange={(e) => { liquidar.setBean({ ...liquidar.bean, 'Description': e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={ajustardocs} updateModal={setajustardocs}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docs}

                                />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={devoluciondocs} updateModal={setdevoluciondocs}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docsvdos}

                                />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={liquidardocs} updateModal={setliquidardocs}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docsvtres}

                                />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={standardsdocs} updateModal={setStandardsdocs}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docsvcinco}

                                />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalticket} updateModal={setModalticket}>
                        <>
                            <div className="row">
                                {/* <div className="col-md-6">
                                <BasicButton eventClick={exportProductionOrdersbyaccion} icon="ri-inbox-archive-line" children={"Exportar a Excel Ordenes de Producción"} />
                            </div> */}

                                <div className="col-md-12">
                                    {formatoticket?.DataBeanProperties?.URLLink && (
                                        // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                        <div className="row">
                                            <div className="col-md-12 mt-3">
                                                <label>Descarga en el Siguiente Link:*</label>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <a href={formatoticket.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                    <strong>📄 {formatoticket.DataBeanProperties.Filename}</strong>
                                                </a>
                                            </div>
                                        </div>

                                    )}
                                </div>
                            </div>

                        </>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={exportdocs} updateModal={setModalexportdocs}>
                        <div className="row">
                            <div className="col-md-12">
                                {formatocuatro?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <a href={formatocuatro.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>{formatocuatro.DataBeanProperties.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={reporte} updateModal={setDescargarreporte}>
                        <div className="row">
                            {formato?.DataBeanProperties?.URLLink && (
                                // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                            <strong>{formato.DataBeanProperties.Filename}</strong>
                                        </a>
                                    </div>
                                </div>

                            )}



                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label >Fecha de la Orden de Producción</label>
                                <InputDate _disable={bean.ProductionOrderDate !== null} name="date" value={bean.ProductionOrderDate} label=" " setDate={(e) => { setBean({ ...bean, "ProductionOrderDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label >Centro de Fabricación</label>
                                <SelectAttentionOffice idSelector={bean.IDAttentionOffice} onChange={(e) => { setBean({ ...bean, "IDAttentionOffice": e }) }} label=" " />
                            </div>
                            <div className="col-md-6">
                                <label >Fecha Inicio Plan</label>
                                <InputDate name="date" value={bean.InitDate} label=" " setDate={(e) => { setBean({ ...bean, "InitDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Fecha Fin Plan</label>
                                <InputDate name="date" value={bean.UptoDate} label=" " setDate={(e) => { setBean({ ...bean, "UptoDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label >Fecha Inicio Real</label>
                                <InputDate name="date" value={bean.RealInitDate} label=" " setDate={(e) => { setBean({ ...bean, "RealInitDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Fecha Finalización Real</label>
                                <InputDate name="date" value={bean.RealUptoDate} label=" " setDate={(e) => { setBean({ ...bean, "RealUptoDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label >Tipo de Solitud</label>
                                <SelectProductionOrderRequestConstants idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} label=" " />
                            </div>
                            <div className="col-md-6">
                                <label >Producto a Producir</label>
                                <SelectProductEditor renderValue={bean.ProductName} filterType={3} label=" " value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Variante/Talla de Producto</label>
                                <SelectProductVariant label=" " idProduct={bean.IDProduct} idSelector={bean.IDProductVariant} onChange={(e) => { setBean({ ...bean, "IDProductVariant": e }) }} />
                            </div>
                            <div className="col-md-6">
                                {/* <SelectManufacturingStandars label="Estandard de Fabricación" idSelector={bean.IDManufacturingStardard} onChange={(e) => { setBean({ ...bean, "IDManufacturingStardard": e }) }} /> */}
                                <ManufacturingStandarsEditor IDManufacturingStardard={bean.IDManufacturingStardard} returnData={(e) => { setBean({ ...bean, "IDManufacturingStardard": e.IDManufacturingStardard }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Rutas de Producción</label>
                                <SelectProductionRoute render={bean.ProductionRouteName} idSelector={bean.IDProductionRoute} onChange={(e) => { setBean({ ...bean, "IDProductionRoute": e.IDProductionRoute, "ProductionRouteName": e.Name }) }} label=" " returnType="Object" />
                                {/* <ProductionRouteSelect idSelector={bean.IDProductionRoute} label="Ruteo de Producción" onChange={(e) => { setBean({ ...bean, "IDProductionRoute": e }) }} /> */}
                            </div>
                            {/* <div className="col-md-6">
                                            <label>Código Orden de Producción</label>
                                            <input type="number" name="Code" className="form-control" value={bean.Code} onChange={handleChange} />
                                        </div> */}
                            <div className="col-md-6">
                                <label>No Solicitud Cliente</label>
                                <input type="number" name="ExternalRequestReference" className="form-control" value={bean.ExternalRequestReference} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <SelectBusinessCore label='Línea de Negocio' returnType="Object" idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e.IDBusinessCore }) }} />
                            </div>
                            {/* <div className="col-md-6">
                                            <label className={`${missingFieldsAdd.includes('IDProject') ? 'has-error' : ''}`}>Proyecto</label>
                                            <SelectProject idSelector={bean.IDProject} onChange={(e) => { setBean({ ...bean, "IDProject": e }) }} label=" " />
                                        </div> */}
                            {/* <div className="col-md-6">
                                            <label className={`${missingFieldsAdd.includes('IDAccount') ? 'has-error' : ''}`}>Cliente Final</label>
                                            <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
                                        </div> */}
                            {/* <div className="col-md-6">
                                            <label className={`${missingFieldsAdd.includes('IDAccount') ? 'has-error' : ''}`}>Cliente Final</label>
                                            <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
                                        </div> */}
                            <div className="col-md-6">
                                <label>Cantidad a Producir</label>
                                <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="Description" className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, 'Description': e.target.value }) }} />
                            </div>
                        </div>
                        {/* <PrintJson json={bean} /> */}
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}